import React from 'react';
import { DataContextProvider } from './contexts/DataContext';
import './styles/main.scss';
import { FJSP_THEME } from './shared/themes/fjsp-material.theme';
import { Layout } from './layout/Layout';
import { CssBaseline, ThemeProvider } from "@mui/material";

function App() {
  return (
    <ThemeProvider theme={FJSP_THEME}>
      <CssBaseline />
      <div className="App">
        <DataContextProvider>
          <Layout />
        </DataContextProvider>
      </div>
    </ThemeProvider>
  );
}

export default App;
